var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text_privacy" }, [
      _c("p", { staticStyle: { "text-align": "center" } }, [
        _c("span", { staticStyle: { "font-size": "18pt" } }, [
          _c("strong", [_vm._v("Privacy Policy")]),
        ]),
      ]),
      _c("h3", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [_vm._v("INTRODUCTION")]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "We recognize that persons who access and/or use (“you” or\n\t\t\t“Users”) our games, whether played on our website, on mobile devices, PCs or on other\n\t\t\tplatforms, (“LUCKYYX GAME”) and other related services, including but not limited to\n\t\t\tcustomer supporting, marketing and advertising, (collectively, the “Services”) value their\n\t\t\tprivacy."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "This Privacy Policy provides important information regarding:"
          ),
        ]),
      ]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "i) the data collected from you and the ways we collect your data,"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("ii) the reasons why we collect your data,"),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("iii) to whom we disclose your data, and"),
        ]),
      ]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("iv) the options you have about your personal data."),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Unless stated otherwise, this Privacy Policy applies to the Services and all\n\t\t\tdata that we collect from you. We therefore provide this Privacy Policy to help you make an informed\n\t\t\tchoice about whether to use or continue using our Services. We may periodically update this Privacy\n\t\t\tPolicy by posting a new version on our website. Your continued use of the Services after the effective\n\t\t\tdate will be subject to the new version of Privacy Policy."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "This Privacy Policy is incorporated into, forms part of and is subject to the\n\t\t\tTerms of Service. Your use of the Services and any personal information you provide on the Site is\n\t\t\tsubject to the terms of this Privacy Policy and the Agreement."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Any terms not defined herein but defined in the Terms of Service shall have\n\t\t\tthe meaning ascribed thereto in the Terms of Service."
          ),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [
              _vm._v(
                " THE DATA COLLECTED FROM YOU AND THE\n\t\t\t\t\tWAYS WE COLLECT YOUR DATA"
              ),
            ]),
          ]),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [_vm._v("1. Data provided by you")]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "To use the Services, you may directly provide certain personally identifiable\n\t\t\tinformation to us, such as:"
          ),
        ]),
      ]),
      _c("ul", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Contact information (e.g. your name, personal identification number,\n\t\t\t\tpostal or e-mail address, telephone numbers)"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Registered user name and password"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Character Information (e.g. Account ID, character name, profile picture.\n\t\t\t\tPlease be reminded that such information may be disclosed to other users in connection with the use\n\t\t\t\tof the Services and may also be made available to your connections or the public on third party\n\t\t\t\tservices)"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Personal content preferences"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Profile information (e.g. profile photo)"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Messages to the Services (e.g. chat logs, your support tickets)"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Billing and financial information (Please be reminded that the use of any\n\t\t\t\tmerchant service provider and/or third party platforms for the payment of the Admission Fee is\n\t\t\t\tsubject to the privacy policy of the relevant merchant service providers and/or third party\n\t\t\t\tplatforms)"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Other data that you voluntarily provide (e.g. data to identify a lost\n\t\t\t\taccount)"
            ),
          ]),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [_vm._v("2. Data collected automatically")]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "When you access our Website or use the Services, we may use cookies and/or\n\t\t\tother similar technologies. Cookies are small text files stored by browser(s) on your desktop computer\n\t\t\tor mobile device. Most web browsers automatically accept cookies, but you can usually modify browser\n\t\t\tsetting to decline cookies. If you choose to decline cookies, you may not be able to access certain\n\t\t\tServices and may experience technical problems receiving current information from the cookie-disabled\n\t\t\tservices. The use of cookies and/or other similar technologies is to identify your browsers and to\n\t\t\tcollect data from your device such as:"
          ),
        ]),
      ]),
      _c("ul", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Data about your Account"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Internet Protocol (IP) address, web request, domain name, URLs,\n\t\t\t\treferring/exit pages, platform type and mobile device identifiers (e.g. your device ID, advertising\n\t\t\t\tID, MAC address, IMEI)"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Data about your device (e.g. device name, operating system, browser type\n\t\t\t\tand language)"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Data we collect with cookies and similar technologies"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Monitoring of aggregate metrics (e.g. total number of visitors, pages\n\t\t\t\tviewed, usage of the Services)"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("General location data"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Precise geo-location data (i.e. GPS)"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Data about your use of the Services (e.g. number of clicks, landing\n\t\t\t\tpages, pages viewed and order of those pages, the amount of time spent on particular pages, the date\n\t\t\t\tand time of your request, your game play and activity, your game progress, your interactions with\n\t\t\t\tother players inside the Services)"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Other pieces of information in connection with your various activities\n\t\t\t\twithin or through the Services or otherwise that are sent by your browser, device or computer system\n\t\t\t\twhen you access the Services, which are automatically tracked and recorded by our servers"
            ),
          ]),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [_vm._v("3. Data collected from our partners")]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "When you access the Services through any third party services such as social\n\t\t\tnetworking sites (e.g. Facebook, WeChat, Google) or from any mobile devices, you allow us access to\n\t\t\tcertain information stored on these third party services or mobile devices such as:"
          ),
        ]),
      ]),
      _c("ul", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Demographic data (e.g. determination of your IP address)"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Data to fight against fraud (e.g. refund abuse in games or click fraud in\n\t\t\t\tadvertising)"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Data from platforms that the games run on (e.g. verification of\n\t\t\t\t payment)"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Data associated with your device (e.g. device type, technological\n\t\t\t\tinformation, telephone number, country, contacts)"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Data to do advertising, marketing and analysis"),
          ]),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [_vm._v(" II. THE REASON WHY WE COLLECT YOUR DATA")]),
          ]),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [_vm._v("1. To provide the Services")]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("To provider the Services, we process data necessary to"),
        ]),
      ]),
      _c("ul", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Create Accounts"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Allow you to play LUCKYYX GAME and use the Services"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Operate the Services"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Verify and confirm payments"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              " Provide and deliver products and services that you request"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Send service-related communications to you"),
          ]),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [_vm._v("2. To improve and optimize the Services")]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "To provide better Services to you, we have a legitimate interest to collect\n\t\t\tand process necessary data to"
          ),
        ]),
      ]),
      _c("ul", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Update and develop the Services"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Manage and update your Account"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Develop and improve your experience"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Manage the relationship with you"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Provide social features to you"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Customize your service experience"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Respond to your comments and questions and provide support to you"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Provide offers in the Services as well as in other websites and\n\t\t\t\tservices"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Send related information (e.g. updates, security alerts, support\n\t\t\t\tmessages) to you"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Enable you to communicate with other users"),
          ]),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [
            _vm._v(
              "3. To carry out activities related to advertisements and\n\t\t\t\tmarketing"
            ),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "To send you personalized advertising and marketing materials, we may use the\n\t\t\tinformation collected from you such as ad identifiers, age, country, region, gender, language, games\n\t\t\tplayed by you, information related to the interaction of you with the Services and with other users, and\n\t\t\tso forth."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "We may also use various third party advertising and marketing partners to\n\t\t\tassist us on our behalf and may share information collected from you with such third parties for this\n\t\t\tpurpose."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Hence, we have a legitimate interest to process necessary data to"
          ),
        ]),
      ]),
      _c("ul", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Track the content you access in connection with the Services and your\n\t\t\t\tonline behavior"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Deliver, target and improve our advertising and marketing\n\t\t\t\tmaterials"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Pass the information collected from you to third party advertising and\n\t\t\t\tmarketing partners"
            ),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "By accepting this Privacy Policy and downloading or continuing to use the\n\t\t\tServices, you consent to us and our advertising and marketing partners collecting and using information\n\t\t\tabout you to personalize advertising and marketing materials and to improve your experience unless you\n\t\t\topt out of receiving this service."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "We encourage you to review the privacy policies of our third party advertising\n\t\t\tand marketing partners so that you can understand how these third parties collect, use and share your\n\t\t\tinformation. We are not responsible for the privacy policies of any third party whether accessed through\n\t\t\tthe Services or otherwise.  "
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "For information on how to opt-out from receiving personalized advertising and\n\t\t\tmarketing materials, see section 'The options you have about your personal data” below."
          ),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [_vm._v("4. To secure the Services")]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Ensuring the security in the course of performing the Services is a top\n\t\t\tpriority for us. We take appropriate security and technical measures to protect your information from\n\t\t\tunauthorized access, loss and misuse. To achieve this purpose, we also request our suppliers who process\n\t\t\tpersonal information on our behalf to take appropriate security measures."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "In order to keep the Service and its social features safe and fair, to fight\n\t\t\tfraud and to ensure acceptable use otherwise, we have a legitimate interest to process necessary data\n\t\t\tto"
          ),
        ]),
      ]),
      _c("ul", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Analyze and monitor use of the Services and its social features"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Moderate and monitor chats"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Prevent cheating, crime or fraud"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("Take action against fraudulent or misbehaving users "),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "Pass your information to agencies or organizations in charge of crime and\n\t\t\t\tfraud prevention and repression"
            ),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Despite our efforts, we cannot guarantee the absolute security of your\n\t\t\tpersonal data, nor can we ensure the security of any of the communication facilities provided by us. We\n\t\t\trecommend that you exercise caution when disclosing any information through the Services. In particular,\n\t\t\tplease note that any personally identifiable information or personally sensitive data that you\n\t\t\tcommunicate or disclose to any user in connection with the Services may be collected and used by others.\n\t\t\tAs such, you should take care of the information shared online. Please also be reminded that any\n\t\t\tquestions answers, comments, submissions that you post in the forum will be publicly available."
          ),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [_vm._v("5. To analyze, research and test")]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "In all of the above cases and purposes, we may use analytic tools, which may\n\t\t\tinclude third party’s analytic tools, to carry out research, surveys and analysis, to create\n\t\t\treports for use, to track potential problems of the Services or to test out new game features and\n\t\t\tcontent."
          ),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [_vm._v("6. To obtain your consent")]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "With your consent, we may process personal data for additional\n\t\t\tpurposes."
          ),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [_vm._v("III. TO WHOM WE DISCLOSE YOUR DATA")]),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [
              _vm._v("1. Our personnel, related or affiliated companies"),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "We may provide your personally identifiable information and\n\t\t\tnon-personally-identifiable information to our personnel, our related or affiliated companies for our\n\t\t\tlegitimate business purposes. We may also provide your personally identifiable information and\n\t\t\tnon-personally-identifiable information to other businesses or persons for the purpose of processing\n\t\t\tsuch information or otherwise assist us in performing any services on our behalf including in any\n\t\t\tadvertising and marketing activities. We require that these parties agree to process such information in\n\t\t\tcompliance with our Privacy Policy contained herein, and we will use reasonable efforts to limit their\n\t\t\tuse of such information and to use other appropriate confidentiality and security measures."
          ),
        ]),
      ]),
      _c("ol", { attrs: { start: "2" } }, [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [_vm._v("2. Other users")]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "As social features are a core element of our games, other users may see your\n\t\t\tprofile data, in-game activities and read the messages you have posted."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Any user who receives any information including personally identifiable\n\t\t\tinformation, from another user shall not disclose or use such information, save where expressly\n\t\t\tpermitted by that user or save where such information has ceased to be of a confidential nature. In any\n\t\t\tevent, we shall not be liable for any unauthorized disclosure or use by another user or other person of\n\t\t\tany content."
          ),
        ]),
      ]),
      _c("ol", { attrs: { start: "3" } }, [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [_vm._v(" 3. Partners working for us")]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "To strengthen functions of our Services and your experience of use, some of\n\t\t\tour Services maybe provided by partners in charge of advertising, payment, analysis, marketing, social\n\t\t\tmedia partners, personalized services, and/or personalized push notifications and recommendations. To\n\t\t\tthe extent of law and for the purposes of advertising, payment, statistic analysis, marketing,\n\t\t\tpersonalized services and/or personalized push notifications and recommendations, we may share with\n\t\t\tthese partners your data, including but not limited to your device information such as its device brand,\n\t\t\tdevice manufacturer, device platform and device ID number, your applications list, internet information\n\t\t\tand GPS location information, that you have consented to our collection. In addition, these partners may\n\t\t\talso access your data when you use their services and operate under their own privacy policies. We\n\t\t\tencourage you to check their privacy policies to learn more about their data processing practices. You\n\t\t\tmay click "
          ),
          _c("u", [_vm._v("here")]),
          _vm._v(" to know the details of the data disclosing."),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [_vm._v("4. Other companies and public authorities")]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "We may release personally identifiable information and/or\n\t\t\tnon-personally-identifiable information to, exchange such information with companies and organizations\n\t\t\tor provide such information to public authorities if required to do so by law, or in the good faith\n\t\t\tbelief that such action is necessary to comply with all and any applicable laws, or where it is pursuant\n\t\t\tto or we are required to respond to a governmental, regulatory, administrative or court order or\n\t\t\tdirective, a subpoena or a search warrant, or to combat fraud and illegal activity."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "We also reserve the right to disclose personally identifiable information\n\t\t\tand/or non-personally-identifiable information that we believe, in good faith, is appropriate or\n\t\t\tnecessary to enforce the Agreement, take precautions against liability, to investigate and defend\n\t\t\tagainst any third-party claims or allegations, to assist government authorities and enforcement\n\t\t\tagencies, to protect the security or integrity of the Services, and to protect the rights, property, or\n\t\t\tpersonal safety of ourselves, our users or others."
          ),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [
              _vm._v(
                " IV. THE OPTIONS YOU HAVE ABOUT YOUR PERSONAL\n\t\t\t\t\tDATA"
              ),
            ]),
          ]),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [
            _vm._v("1. Opt out of advertising and/or marketing materials"),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "You may opt out of receiving advertising and/or marketing communications by\n\t\t\tfollowing the instructions in such communications or by using options provided in the settings in the\n\t\t\tgame or on your devices."
          ),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [
            _vm._v(
              "2. Access and correct the personal data we hold about\n\t\t\t\tyou"
            ),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "You have the right to access and correct your personal data."
          ),
        ]),
      ]),
      _c("h4", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _c("strong", [_vm._v("3. Other rights")]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "You also have the right to have your personal data deleted, object how we use\n\t\t\tor share your personal data, and restrict how we use or share your personal data. You can always\n\t\t\twithdraw your consent."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "If you have questions about data protection, or any requests for resolving\n\t\t\tissues with your personal data, we encourage you to primarily contact us through the game so we can\n\t\t\treply to you more quickly. We will respond to all requests within a reasonable time frame."
          ),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [_vm._v("V. INTERNATIONAL DATA TRANSFERS")]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "By accepting this Privacy Policy, Users understand and agree that your data\n\t\t\tmay be collected, stored, used in any country and/or transferred to any country in the world. Because\n\t\t\tdifferent countries may have different data protection laws than Users’ own country, we will try\n\t\t\tto ensure that adequate safeguards are in place to protect Users’ data."
          ),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [_vm._v(" VI. SPECIAL NOTE TO INTERNATIONAL USERS")]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "The use of the Website and Services and this Agreement is governed by and\n\t\t\tshall be construed and enforced under the laws of Singapore, without applying any conflicts of law\n\t\t\tprinciples that would require application of the law of any other jurisdiction. You agree to submit to\n\t\t\tthe personal non-exclusive jurisdiction in Singapore and any other court of competent jurisdiction\n\t\t\tchosen by us."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "In the event of any dispute arising out of or in connection with this\n\t\t\tAgreement, including any question regarding its existence, validity or termination, (a\n\t\t\t“Dispute”), we strongly encourage that a resolution first be sought through our Customer\n\t\t\tSupport service."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'You agree that in the event that a resolution is not obtained through our\n\t\t\tCustomer Support service, such Dispute shall be referred by you and may be referred by us to and finally\n\t\t\tresolved by arbitration in Singapore in accordance with the Arbitration Rules of the Singapore\n\t\t\tInternational Arbitration Centre ("SIAC Rules") for the time being in force, which rules are deemed to\n\t\t\tbe incorporated by reference in this clause. The Tribunal shall consist of three (3) arbitrators, with\n\t\t\tyou appointing one (1) arbitrator and us appointing one (1) arbitrator and the third arbitrator to be\n\t\t\tselected by the two (2) arbitrators so appointed. The language of the arbitration shall be\n\t\t\tEnglish.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Notwithstanding any of the foregoing, you agree that we are entitled to submit\n\t\t\tsuch Dispute for resolution through any other dispute resolution mechanism including the courts of any\n\t\t\tjurisdiction and we shall further be entitled to seek any injunctive or other equitable relief in the\n\t\t\tevent of any breach or anticipatory breach by you, without any obligations of providing any bond or\n\t\t\tsurety or proof of damages."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "You irrevocably waive all rights to seek any injunctive or other equitable\n\t\t\trelief or to enjoin or restrain the operation or exploitation of the Services or any part thereof. You\n\t\t\tfurther irrevocably waive all rights to a class or representative action or as a named or unnamed member\n\t\t\tin a class, consolidated, representative or private attorney general action."
          ),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [_vm._v("VII. OUR POLICIES CONCERNING CHILDREN")]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "The Services are not intended to be accessed by persons under the age of 13,\n\t\t\tnor do we knowingly collect or solicit personal data therefrom. In the event that we learn that we have\n\t\t\tinadvertently gathered personally identifiable information from persons under the ages set out below, we\n\t\t\twill take commercially reasonable measures to ensure that such information is removed from our\n\t\t\trecords."
          ),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [_vm._v(" VIII. DATA SECURITY")]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "We use commercially reasonable physical, managerial, and technical safeguards\n\t\t\tto preserve the integrity and security of your personal information. We cannot, however, ensure or\n\t\t\twarrant the security of any information you disclose on, through or within the Services and you do so\n\t\t\tentirely at your own risk. Please note that we cannot guarantee that such information may not be\n\t\t\taccessed, disclosed, altered, or destroyed by breach of any of our physical, technical, or managerial\n\t\t\tsafeguards."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "If we learn of a security systems breach, we may attempt to notify you\n\t\t\telectronically so that you can take appropriate protective steps. We may post a notice on the Website if\n\t\t\ta security breach occurs."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "If you create an Account with the LUCKYYX GAME Platform, you will be\n\t\t\trequired to select a password that can be changed at any time after you first log into the Account by\n\t\t\tusing your current password. You are solely responsible for maintaining the confidentiality of your\n\t\t\tpassword and are fully responsible for all activities that occur under your Account and password or your\n\t\t\taccount with any other third party service. Users agree to (i) notify us immediately if you are aware or\n\t\t\treasonably suspect of any unauthorized use of your Account or password or of any unauthorized access of\n\t\t\tthe Services through your Account, and (ii) ensure that you exit from your Account at the end of each\n\t\t\tsession."
          ),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [
              _vm._v(" IX. MERGER, ACQUISITION, SALE OR INSOLVENCY"),
            ]),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "1. In the event that we are acquired by or merged with another entity, we\n\t\t\t\treserve the right, in any of these circumstances, to transfer the information or assign our rights\n\t\t\t\tto the information that we have collected from our Users as part of such merger, acquisition, sale,\n\t\t\t\tor other change of control."
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "2. In the event of our insolvency, reorganization, receivership,\n\t\t\t\twinding-up or assignment for the benefit of creditors, or the application of laws or equitable\n\t\t\t\tprinciples affecting creditors' rights generally, we may not be able to control how your personal\n\t\t\t\tinformation is treated, transferred, or used."
            ),
          ]),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v("X. Notes on Facebook Information Collection and Removal"),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "1. When a user logs into the application with a Facebook authorization,\n\t\t\t\twe will collect the user's email address and personal public information, which is mainly used to\n\t\t\t\tcreate an account and provide personalized services"
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "2. When users delete the game application or remove the application\n\t\t\t\tauthorization in Facebook settings and privacy, we will delete all the user's information."
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "3. If you no longer use Facebook authorization to login, you can contact\n\t\t\t\tus to delete your Facebook authorization data and content information, which cannot be restored once\n\t\t\t\tdeleted."
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _c("strong", [_vm._v("XI")]),
            _c("strong", [_vm._v(".")]),
            _c("strong", [_vm._v("Notes on account\n\t\t\t\t\tdeletion")]),
          ]),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("ol", [
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              '1. Users delete their accounts according to their own wishes, deletion of\n\t\t\t\tthe account is deemed to agree to our "Account Deletion Agreement", you agree to reach this\n\t\t\t\tagreement with our company, and voluntarily accept all the terms of the agreement.'
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "2. Account deletion is a non-recoverable operation, after deleting the\n\t\t\t\taccount, you will not be able to use the account to log in to all of our products and services, and\n\t\t\t\tyou will not be able to retrieve any of the content and information that you have added or bound\n\t\t\t\tthrough the account, even if you choose the same mailbox to register again and use the products and\n\t\t\t\tservices related to the account of the Division I. You will not be able to use the account to access\n\t\t\t\tour products and services, even if you choose the same mailbox."
            ),
          ]),
        ]),
        _c("li", [
          _c("span", { staticStyle: { "font-size": "12pt" } }, [
            _vm._v(
              "3. Account deletion Once the account is cancelled, all content,\n\t\t\t\tinformation, data, records under the account registration, use of account-related products and\n\t\t\t\tservices will be deleted or anonymized (except as otherwise provided by laws and regulations). You\n\t\t\t\tare voluntarily responsible for all consequences that may arise."
            ),
          ]),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'As used in this Privacy Policy, "LUCKYYX GAME", "we", "us", or "our" refer to\n\t\t\tLUCKYYX  Limited and all of its subsidiaries. For detailed contact information, visit our Contact\n\t\t\tUs page below.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'Our Privacy Policy applies only to the collection and processing of the Data\n\t\t\tthat you may decide to provide to us in your use of: (i) our applications for mobile platforms or\n\t\t\tdevices and our web applications accessible on third party social networking services ("SNS")\n\t\t\t(collectively, our mobile and web applications are referred to herein as ("LUCKYYX\n\t\t\tGAME Applications"), (ii) our game publisher networks, crowd sourcing service and platforms\n\t\t\t("Networks") provided in connection with LUCKYYX GAME Applications and Third-Party Mobile\n\t\t\tApplications (defined below), (iii) our portal for third-party publishers ("LUCKYYX GAME Developer\n\t\t\tPortal"), (iv) our web domains and subdomains, including member.hwxgame.com (collectively, our\n\t\t\t"Sites"), and web forums or messaging boards in LUCKYYX GAME Applications and our Sites\n\t\t\t(collectively, our "Forums"). Any and all of our LUCKYYX GAME Applications, Networks, LUCKYYX\n\t\t\tGAME Developer Portal, Sites and Forums are referred to herein as our "Services".'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'LUCKYYX GAME respects the privacy of online visitors and customers of our\n\t\t\tServices and complies with applicable laws for the protection of your privacy, including, without\n\t\t\tlimitation, the European Union General Data Protection Regulation ("GDPR") and the Swiss and EU Privacy\n\t\t\tShield Frameworks. We designed this Privacy Policy to provide you with an overview of the processes of\n\t\t\tthe processing of personal information when using our Services, so that you can understand them. Please\n\t\t\tbe sure to familiarize yourself with our privacy practices and let us know if you have any\n\t\t\tquestion.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "To contact our Chief Information Security Officer who is also acting as the\n\t\t\tData Protection Officer, please write to dragon@luckyyx.com."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'We reserve the right to update this Privacy Policy at any time. If we modify\n\t\t\tthis Privacy Policy in a material way, a notice may be posted in our Services and on the Sites along\n\t\t\twith the updated Privacy Policy. We will also update the "Last Updated Date" in the Privacy Policy. By\n\t\t\tcontinuing to access or use the Services after we have posted an updated Privacy Policy or have provided\n\t\t\tyou with notice of a modification, you are indicating that you agree to be bound by the modified Privacy\n\t\t\tPolicy. If the modified Privacy Policy is not acceptable to you, you should cease using the\n\t\t\tServices.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'Please visit this page periodically to remain up-to-date as to any Privacy\n\t\t\tPolicy changes. Take a moment now to read the following to learn about our information collection\n\t\t\tpractices that may impact you as a registered user with access to our Services or a non-registered user\n\t\t\tof our Services (each a "LUCKYYX GAME User"). For information regarding the collection and use of\n\t\t\tPersonal Information (defined below) from children under 14 years old, see the Section below, entitled\n\t\t\t"Our Policy Toward Children".'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("WHAT IS PERSONAL DATA AND NON-IDENTIFYING INFORMATION?"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'Wherever we talk about Personal Data below, we mean any information that can\n\t\t\teither itself identify you as an individual ("Personally Identifying Information") or that can be\n\t\t\tconnected to you indirectly by linking it to Personally Identifying Information. In the course of using\n\t\t\tour Services, we may ask you to provide us with certain personally identifiable information that can be\n\t\t\tused to contact or identify you. Personally identifiable information may include, but is not limited to,\n\t\t\tyour name, phone number, photo representation ("avatar"), email address and mailing address ("Personal\n\t\t\tInformation").'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'We also collect non-personal information, which is data in a form that does\n\t\t\tnot permit direct association with you or any specific individual ("Non-Identifying Information").\n\t\t\tNon-Identifying Information is aggregated and used to help improve our Services and Third Party Mobile\n\t\t\tApplications by providing a better way to understand the LUCKYYX GAME User experience with the\n\t\t\tlevel of interest in various portions of our Sites, specific LUCKYYX GAME Applications or specific\n\t\t\tThird-Party Mobile Applications. We may collect and process Non-Identifying Information for any purpose;\n\t\t\tdetails provided in this Privacy Policy about what Non-Identifying Information we collect currently, and\n\t\t\thow we use, transfer and disclose such Non-Identifying Information concern only how such information is\n\t\t\tcollected and used today.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Either Personal Information or Non-Identifying Information may be used alone\n\t\t\tor in the aggregate with information collected from other LUCKYYX GAME Users. Our primary objective\n\t\t\tin collecting any Personal Information or Non-Identifying Information is to provide you with a superior\n\t\t\tand personally relevant user experience."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("WHAT DATA WE COLLECT AND PROCESS"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "LUCKYYX GAME collects and processes Personal Data in the following\n\t\t\toccasions:"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "1.Where it is necessary for the performance of our agreement with you to\n\t\t\tprovide a full-featured gaming service and deliver associated Content and Services;"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "1.Where it is necessary for the performance of our agreement with you to\n\t\t\tprovide a full-featured gaming service and deliver associated Content and Services;"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "3.Where it is necessary for the purposes of the legitimate and legal interests\n\t\t\tof LUCKYYX GAME or a third party (e.g. the interests of our other customers), except where such\n\t\t\tinterests are overridden by your prevailing legitimate interests and rights;"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("4.Where you have given consent to it."),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Depending on the circumstances in which you use our services, we may collect\n\t\t\tand process different kinds of your Personal Information. The typical circumstances and specific types\n\t\t\tof information can be found in the table below:"
          ),
        ]),
      ]),
      _c("table", [
        _c("tbody", [
          _c("tr", [
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Circumstances of Collecting Personal Information"),
                ]),
              ]),
            ]),
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v(
                    "Categories of Personal Information We May Collect100"
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("tr", [
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Your Registration of LUCKYYX GAME"),
                ]),
              ]),
            ]),
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Email address; Information on mobile device type,"),
                ]),
              ]),
            ]),
          ]),
          _c("tr", [
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Users on our Services"),
                ]),
              ]),
            ]),
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v(
                    'mobile carrier, unique mobile device identifier ("Device\n\t\t\t\t\t\t\tID");'
                  ),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v('Internet Protocol ("IP")\n\t\t\t\t\t\t\taddress;'),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Geo-location."),
                ]),
              ]),
            ]),
          ]),
          _c("tr", [
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Your Registration as a Third Party Publisher"),
                ]),
              ]),
            ]),
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Name;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Mailing\n\t\t\t\t\t\t\taddress;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Email address;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Telephone number;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Bank account for vendor registration;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Taxation information for vendor registration."),
                ]),
              ]),
            ]),
          ]),
          _c("tr", [
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Making a purchase on our Services"),
                ]),
              ]),
            ]),
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Payment data;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v(
                    "Typical credit card information (name, address, credit card\n\t\t\t\t\t\t\tnumber, expiration date and security code);"
                  ),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Data from your payment service provider."),
                ]),
              ]),
            ]),
          ]),
          _c("tr", [
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Linking your LUCKYYX GAME account to an SNS"),
                ]),
              ]),
            ]),
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v(
                    "Username, alias and any other Personal Information you have\n\t\t\t\t\t\t\tindependently submit, provided to and made accessible through the SNS, if you consent to\n\t\t\t\t\t\t\tLUCKYYX GAME’s access."
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("tr", [
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Participating in our Promotion"),
                ]),
              ]),
            ]),
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Email address;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Mailing address."),
                ]),
              ]),
            ]),
          ]),
          _c("tr", [
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Usage of our Services"),
                ]),
              ]),
            ]),
            _c("td", [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Device type;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Mobile\n\t\t\t\t\t\t\tcarrier;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("IP address;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Platform version;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Geo-location;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v("Navigation;"),
                ]),
                _c("br"),
                _c("span", { staticStyle: { "font-size": "12pt" } }, [
                  _vm._v(
                    "Interaction and engagement information regarding LUCKYYX GAME\n\t\t\t\t\t\t\tUsers."
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("WHY DO WE COLLECT AND PROCESS DATA"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Your Personal Information may be used, for instance:"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "1.To help us to develop, deliver, and improve our Services and\n\t\t\tadvertising;"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("2.To recommend products of interest directly to you;"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "3.For market research purposes that support our efforts to deliver a more\n\t\t\tvaluable service to our community of LUCKYYX GAME Users;"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "4.With your prior consent and your confirmation of the opt-in link sent to the\n\t\t\te-mail address mentioned in your application form, we may occasionally email you with offers,\n\t\t\tpromotions, and/or information of interest. To opt out of emails from us, please follow the unsubscribe\n\t\t\tinstructions contained in the relevant emails or contact us at dragon@luckyyx.com"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "5.To allow us to keep you posted regarding our latest Service announcements,\n\t\t\tsoftware updates, and upcoming events;"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "6.To send important notices, such as communications about your purchases and\n\t\t\tchanges to our Terms of Use, this Privacy Policy, or other Service-specific policies. Because this\n\t\t\tinformation is important to your interactions with LUCKYYX GAME, you may not opt out of receiving these\n\t\t\tcommunications."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "7.To audit and analyze data to improve our Services and customer\n\t\t\tcommunications."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("DURATION OF STORAGE"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Unless otherwise stated in the following sections, we will store the data only\n\t\t\tas long as necessary to achieve the purpose of processing or to fulfill our contractual or statutory\n\t\t\tobligations."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("COOKIES & OTHER TECHNOLOGIES"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'As is standard practice, we use "cookies" to help us study traffic patterns\n\t\t\tand understand the effectiveness of our marketing communications. A cookie is a small string of text\n\t\t\tthat we send to your computer’s or mobile device\'s browser. Other types of cookies exist, but the\n\t\t\tcookies we use in connection with our Services are only used to obtain browser-specific information. For\n\t\t\texample, we do not use cookies to retrieve data from your hard drive, pass on computer viruses, or\n\t\t\tcapture your email address. Cookies we use can reveal, for instance, which pages are the most popular,\n\t\t\thow much time LUCKYYX GAME Users are spending there, and how they are interacting with the content\n\t\t\ton such pages.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "You have the option to disable cookies by changing the options in your browser\n\t\t\tto stop accepting cookies or to prompt you before accepting a cookie from the pages you visit. If you do\n\t\t\tnot accept cookies, however, you may not be able to view or use all portions of our Services due to\n\t\t\tlimited functionality."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'Some of our Services, including email messaging, use "click-through URLs"\n\t\t\tlinked to other content on our Services. We track this click-through data to help us determine interest\n\t\t\tin topics, Services usability and other measures of LUCKYYX GAME User engagement.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'We may also use "pixel tags," "web beacons," "clear GIFs" or similar means\n\t\t\t(individually or collectively "Pixel Tags") in connection with our Services and to collect usage,\n\t\t\tdemographic and geographical location data. A Pixel Tag is an electronic image, often a single pixel\n\t\t\tthat is ordinarily not visible to users and may be associated with cookies on a user’s hard drive.\n\t\t\tPixel Tags allow us to count users who have visited certain pages of the Sites, to deliver branded\n\t\t\tservices and to help determine the effectiveness of promotional or advertising campaigns.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'When you use our Services or Third-Party Mobile Applications, our servers\n\t\t\tautomatically record information that your browser or the applicable Service or Third-Party Mobile\n\t\t\tApplication sends ("Log Data"). This Log Data may include information such as your computer’s or\n\t\t\tmobile device’s IP address, browser type, language, Internet Service Provider (ISP), referring and\n\t\t\texit pages, time spent, information searched for, time and date stamp, clickstream data and other\n\t\t\tstatistics. We use this information to monitor, analyze and understand trends, for technical\n\t\t\tadministration of Services and Third-Party Mobile Applications, and to gather demographic information\n\t\t\tabout our LUCKYYX GAME User base as a whole. We, and Third Party Publishers may use this\n\t\t\tinformation for product and services improvements, and in marketing and advertising services.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'BY CLICKING ON THE "SIGN UP" BUTTON, WHERE APPLICABLE, OR OTHERWISE BY\n\t\t\tACCESSING OR USING OUR SERVICES YOU ARE CONSENTING TO THE USE OF COOKIES AND OTHER TRACKING TECHNOLOGIES\n\t\t\tON YOUR DEVICE.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "WHEN WE DISCLOSE YOUR INFORMATION WITH LUCKYYX GAME SERVICES"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "As a user with an account, you may create your own profile, connect with other\n\t\t\tLUCKYYX GAME Users of Services, send messages and transmit information through various channels.\n\t\t\tPlease remember that any communications you have via our Services, depending on, for example, the\n\t\t\tfunctionality of any LUCKYYX GAME Application or Third-Party Mobile Application connected to our\n\t\t\tServices, may reveal your screen name and the content of your communications, making this information\n\t\t\tpublicly available to other LUCKYYX GAME Users. LUCKYYX GAME is not responsible for the\n\t\t\tactivities of other LUCKYYX GAME Users or other third parties with whom you choose to provide your\n\t\t\tPersonal Information or otherwise interact."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("With Third Parties for Industry Analysis"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'In addition to sharing aggregated Non-Identifying Information with Third Party\n\t\t\tPublishers, we may also share aggregated Non-Identifying Information with advertisers and ad networks\n\t\t\t("Advertising Entities") with whom we have strategic relationships. Unless you specifically opt in to\n\t\t\tshare your Personal Information, the information that we share with these third parties will only be\n\t\t\tused in the form of Non-Identifying Information to support user trend analyses and demographic\n\t\t\tprofiling. Some Third Party Publishers and Advertising Entities also act as Service Providers (defined\n\t\t\tbelow) to us, so in those cases we will share your information as described below.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("With Preferred Partners"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'We may share your username, email address, MAC address and Device ID\n\t\t\t(collectively, "Specific Shared Data") with certain of our Third Party Publishers and other business\n\t\t\tpartners ("Preferred Partners") for those parties to assist us with providing you with the aspect of the\n\t\t\tServices for which you provided such Specific Shared Data to us, and to use such Specific Shared Data to\n\t\t\tprovide you with information and marketing materials about Third Party Mobile Applications and other\n\t\t\tproducts and services in order, for example, to further enhance your use of our Services and to augment\n\t\t\tyour gaming and social networking experience generally. In addition, in the event of a user inquiry\n\t\t\tconcerning Third Party Publishers or Third Party Applications, we may send Specific Shared Data as well\n\t\t\tas the inquiry to a Preferred Partner to address the inquiry.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'We only share such information with Preferred Partners pursuant to an\n\t\t\tagreement by which the Preferred Partner is under obligations not to disclose or use it for any other\n\t\t\tpurpose. You may contact us by any of the means provided in the "Contacting Us" section below to request\n\t\t\tnot to have such information provided to Preferred Partners, understanding, however, that if such\n\t\t\tinformation is not shared with Preferred Partners it may affect your ability to use or access portions\n\t\t\tof the Services.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Some Preferred Partners also act as Service Providers (defined below) to us,\n\t\t\tand in those cases we may also share Personal Information and Non-Identifying Information as described\n\t\t\tbelow."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("With Third Party Social Networking Services (SNSs)"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "As a user with an account, you may link your LUCKYYX GAME account\n\t\t\tinformation with certain SNSs where other LUCKYYX GAME Users have existing SNS accounts. In these\n\t\t\tinstances, with your permission and on your behalf, we will share your email address and screen name or\n\t\t\talias with the applicable SNS. Through use of such services’ application programming interfaces\n\t\t\t(APIs) we can receive certain information (which may include your Personal Information) in accordance\n\t\t\twith the privacy settings you have set in your SNS account, if any."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Other than what we may share with the SNS in connection with your linking of\n\t\t\taccounts, the personal information an SNS has about you is obtained by the SNS independent of our\n\t\t\tServices. Other services follow different rules regarding the use or disclosure of the personal\n\t\t\tinformation you submit to them. We encourage you to read the privacy policies or statements of the other\n\t\t\tservices you use."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("With our Service Providers"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'Disclosure of your Personal Information and Non-Identifying Information may\n\t\t\talso occur where we engage or employ service providers, vendors or other third party entities to\n\t\t\tfacilitate provision of our Services (each a "Service Provider") (e.g., without limitation, improvement\n\t\t\tof our Services’ features, user account authentication, promotion and marketing, administration,\n\t\t\tanalytics, virtual currency transactions, crowd-sourcing, cloud storage and other related services), to\n\t\t\tprovide the Services on our behalf, or to assist us in analyzing how our Services are being used. Our\n\t\t\tService Providers may have access to your Personal Information only to perform these tasks on our behalf\n\t\t\tand are obligated not to disclose or use it for any other purpose.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Under Special Circumstances"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "At times, we may disclose information about you to law enforcement officials\n\t\t\tor private parties as we, in our sole discretion, believe necessary or appropriate to respond to claims\n\t\t\tand legal process (including but not limited to subpoenas), to protect the property and rights of\n\t\t\tLUCKYYX GAME or a third party, to protect the safety of the public or any person or to prevent or\n\t\t\tstop activity we may consider to be or to pose a risk of being, any illegal, unethical or legally\n\t\t\tactionable activity."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Under another special set of circumstances, for example, in connection with a\n\t\t\tmerger, acquisition, reorganization or sale of assets, or in the event of bankruptcy, we may sell,\n\t\t\ttransfer or otherwise share some or all of LUCKYYX GAME assets, including your Personal\n\t\t\tInformation."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("OUR POLICY TOWARD CHILDREN"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'Our Services are not intended for children under the age of 14 ("children")\n\t\t\tand we do not knowingly collect any Personal Information from children. If we discover that we have\n\t\t\tinadvertently collected Personal Information from children, we will take all reasonable measures to\n\t\t\terase such information from our systems and records as soon as possible.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("USE AS A NON-REGISTERED USER"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "In certain LUCKYYX GAME Applications, an LUCKYYX GAME User may\n\t\t\tparticipate as a non-registered LUCKYYX GAME User through optional registration. This allows an\n\t\t\tLUCKYYX GAME User to play the game in a limited capacity. LUCKYYX GAME does not collect any\n\t\t\tPersonal Information or Non-Identifying information, other than Device ID, for non-registered users.\n\t\t\tLUCKYYX GAME cannot and does not ensure the preservation of game data that is associated with any\n\t\t\tnon-registered account."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("LOCATION-BASED SERVICES"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "For location-based Services, we may collect, use, and share precise location\n\t\t\tdata, including the real-time geographic location of your computer or mobile device. Unless you\n\t\t\texplicitly opt-in to permit the use and sharing of your Personal Information regarding your geographic\n\t\t\tlocation, your location data will only be collected and used anonymously in a form that does not\n\t\t\tpersonally identify you. When you opt in to Third Party Mobile Application providers’ location\n\t\t\tservices, we will share your geographic location with such Third Party Mobile Application providers in\n\t\t\tconnection with their location services. Please note that some location-based services may require your\n\t\t\tPersonal Information for the feature to work as intended."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("INVITE-A-FRIEND"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "If you choose to use our referral services to tell a friend about our\n\t\t\tServices, we will ask you for your friend’s name and email address. We will automatically send\n\t\t\tyour friend a one-time email inviting him or her to use an aspect of our Services. LUCKYYX\n\t\t\tGAME hashes these email addresses after using them for the sole purpose of sending this one-time\n\t\t\temail."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("LUCKYYXILING VIA A LUCKYYX GAME APPLICATION"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'LUCKYYX GAME Users may send pre-formatted messages through use of their\n\t\t\tpersonal email account connected to their mobile device to, for example, challenge their friends to beat\n\t\t\ttheir high score in an LUCKYYX GAME Application where this functionality is available. LUCKYYX\n\t\t\tGAME may store the email address of the friend that you choose to email via our Services, but would\n\t\t\tonly do so for social purposes such as generating friend recommendations (e.g., in connection with\n\t\t\t"people you may know" functionality). The message you initiate will be sent through your personal email\n\t\t\taccount to the email addresses you choose.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("HOW WE PROTECT YOUR PERSONAL INFORMATION"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "LUCKYYX GAME takes your privacy very seriously and employs\n\t\t\tadministrative, physical and electronic measures to safeguard your information from identity theft and\n\t\t\tunauthorized access. We do not and will not, at any time, request your credit card information, your\n\t\t\taccount ID, login password or national identification numbers in a non-secure or unsolicited\n\t\t\tcommunication (e.g. via e-mail, telephone, mobile device)."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'We will make any legally required disclosures of any breach of the security,\n\t\t\tconfidentiality, or integrity of your unencrypted electronically stored "personal data" (as defined in\n\t\t\tapplicable state statutes on security breach notification) to you via email or conspicuous posting on\n\t\t\tthe Sites in the most expedient time possible and without unreasonable delay, insofar as consistent with\n\t\t\t(i) the legitimate needs of law enforcement or (ii) any measures necessary to determine the scope of the\n\t\t\tbreach and restore the reasonable integrity of the data system.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("YOUR RIGHTS"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "The data protection laws of the European Economic Area and other territories\n\t\t\tgrant their citizens certain rights in relation to their Personal Data. While other jurisdictions may\n\t\t\tprovide fewer statutory rights to their citizens."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "As a user of an account, you may update or delete the Personal Information in\n\t\t\tyour profile by logging into your account. You may also email us at LUCKYYXboss@hwxgame.com to\n\t\t\trequest that we delete your Personal Information from our database. We will use commercially reasonable\n\t\t\tefforts to honor your request. We may retain an archived copy of your records as required by law or for\n\t\t\tlegitimate business purposes. Specific Shared Data cannot be retrieved from Preferred Partners after its\n\t\t\tdisclosure."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Where you share information with other users through the communication\n\t\t\tchannels of our Services, you generally should not expect to have any ability to modify or remove such\n\t\t\tcommunications. Nor should you expect us to modify or delete your comments upon your request."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "If you participate in a Promotion hosted by us (where you may or may not\n\t\t\tdisclose the information requested), you have the option to opt out at any time from such participation\n\t\t\tand the receipt of any related communications. Please follow the unsubscribe instructions provided in\n\t\t\tthe relevant communications."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "If your friend received an invitation from LUCKYYX GAME per your referral\n\t\t\tto try the Services, your friend may request that the name and email address used in the invitation be\n\t\t\tremoved from LUCKYYX GAME’s records. We store this information for the sole purposes of measuring\n\t\t\tthe effectiveness of our referral program and sending the email you initiated, but your friend can\n\t\t\trequest to have it removed from our database by emailing us at @luckyyx.com.."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "As a resident of the European Economic Area you have the following rights in\n\t\t\trelation to your Personal Data:"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("1.Right of Access."),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "You have the right to access your Personal Data that we hold about you, i.e.\n\t\t\tthe right to require free of charge (i) information whether your Personal Data is retained, (ii) access\n\t\t\tto and/or (iii) duplicates of the Personal Data retained. You can use the right to access to your\n\t\t\tPersonal Data. If the request affects the rights and freedoms of others or is manifestly unfounded or\n\t\t\texcessive, we reserve the right to refuse to act on the request."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("2.Right to Rectification."),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "If your Personal Data is inaccurate or incomplete, you can change the\n\t\t\tinformation in your profile by logging into your account, for those non-editable Data in your profile,\n\t\t\tyou may email us at dragon@luckyyx.com to make a request. If we process your Personal Data, we\n\t\t\tshall endeavor to ensure by implementing suitable measures that your Personal Data is accurate and\n\t\t\tup-to-date for the purposes for which it was collected."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("3.Right to Erasure."),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "You have the right to obtain deletion by us of Personal Data concerning you by\n\t\t\temail us at dragon@luckyyx.com  to request that we delete your LUCKYYX Account.As a result of\n\t\t\tdeleting your LUCKYYX Account, you will lose access to our Services you are using the\n\t\t\tLUCKYYX Account for."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "We allow you to restore your LUCKYYX Account during a grace period of 30\n\t\t\t(thirty) days from the moment you request deletion of your LUCKYYX Account. This functionality\n\t\t\tallows you not to lose your account by mistake, because of your loss of your account credentials or due\n\t\t\tto hacking. During the suspension period, we will be able to finalize financial and other activities\n\t\t\tthat you may have initiated before sending the LUCKYYX Account deletion request. After the grace\n\t\t\tperiod, Personal Data associated with your account will be deleted from our database. In some cases,\n\t\t\tconsidering the complexity and number of the requests, the period for Personal Data erasure may be\n\t\t\textended, but for no longer than two further months."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("4.Right to Object."),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "When our processing of your Personal Data is based on legitimate interests\n\t\t\taccording to Article 6(1)(f) of the GDPR / section 2.c) of this Privacy Policy, you have the right to\n\t\t\tobject to these processing. If you object we will no longer process your Personal Data unless there are\n\t\t\tcompelling and prevailing legitimate grounds for the processing as described in Article 21 of the GDPR;\n\t\t\tin particular if the data is necessary for the establishment, exercise or defense of legal\n\t\t\tclaims."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "5.You also have the right to lodge a complaint at a supervisory\n\t\t\tauthority."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("LINKS TO OTHER WEBSITES AND SERVICES"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'Our Services may contain links to other websites and online services or offers\n\t\t\tfrom third parties. For example, our Services may include offers from third party advertisers or the\n\t\t\tability to engage in transactions with such entities. If an LUCKYYX GAME User with an account\n\t\t\tchooses to participate in offer-linked information requests or "clicks on" an advertisement or another\n\t\t\tthird party link, such LUCKYYX GAME User may be directed to that third party’s website or\n\t\t\tservice and/or be prompted to provide Personal Information in connection with such activity.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "The fact that we link to a third party website or service is not an\n\t\t\tendorsement or representation of our affiliation with that third party, nor is it an endorsement of such\n\t\t\tthird party’s privacy or information security policies or practices or their compliance with laws.\n\t\t\tWe do not exercise control over third party websites or services. These other websites or services may\n\t\t\tplace their own cookies or other files on your computer or mobile devices, collect data or solicit\n\t\t\tpersonal information from you. Other websites and services follow different rules regarding the use or\n\t\t\tdisclosure of the personal information you submit to them. We encourage you to read the privacy policies\n\t\t\tor statements of the other websites and services you use and the terms of the offers in which you\n\t\t\tparticipate. You agree that LUCKYYX GAME is not responsible for, nor will it be liable to you or\n\t\t\tany third party for, your interaction with such third parties or the information requests initiated by\n\t\t\tsuch third parties or the subsequent use, treatment or dissemination of the information you voluntarily\n\t\t\tchoose to provide to them."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "ADDITIONAL INFORMATION FOR USERS FROM THE EUROPEAN ECONOMIC AREA"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Information that you provide may be transferred or accessed by entities around\n\t\t\tthe world as described in this Privacy Policy. If you are located in European Economic Area, you\n\t\t\tunderstand that we may transfer Personal Information to and process it in the United States. Your\n\t\t\tconsent to this Privacy Policy followed by your submission of Personal Information represents your\n\t\t\tagreement to that transfer."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "LUCKYYX GAME abides by the EU-U.S. Privacy Shield Framework and the\n\t\t\tSwiss-U.S. Privacy Shield Framework as set forth by the U.S. Department of Commerce regarding the\n\t\t\tcollection, use, and retention of personal information transferred from the European Union and\n\t\t\tSwitzerland to the United States. If there is any conflict between the terms in this privacy policy and\n\t\t\tthe Privacy Shield Principles, the Privacy Shield Principles shall govern. To learn more about the\n\t\t\tPrivacy Shield program, and to view our certification, please visit http://www.privacyshield.gov."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Individuals who wish to file a complaint or who take issue with our privacy\n\t\t\tpolicies should first contact us here. If you are sending us a privacy-related complaint, please provide\n\t\t\tit in English because this will help expedite the process. We will investigate and attempt to resolve\n\t\t\tcomplaints regarding use and disclosure of personal information in accordance with the principles\n\t\t\tcontained in this Privacy Policy. For complaints that cannot be resolved between LUCKYYX GAME and a\n\t\t\tcomplainant, we commit to cooperate with data protection authorities located in the European Union, the\n\t\t\tSwiss Federal Data Protection and Information Commissioner, or their authorized representatives to\n\t\t\tresolve such disputes."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("YOUR CALIFORNIA PRIVACY RIGHTS"),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'California Civil Code Section 1798.83 permits customers of LUCKYYX\n\t\t\tGAME who are California residents to request certain information regarding our disclosure of\n\t\t\tpersonal information to third parties for their direct marketing purposes. If you are a California\n\t\t\tresident and have provided LUCKYYX GAME with personal information within the last year, you may\n\t\t\tmake such a request by emailing us at the following email address with the email’s subject titled\n\t\t\tas "California Privacy Rights": dragon@luckyyx.com.'
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            "Within thirty (30) calendar days of receiving such a request, we will provide\n\t\t\ta list of the categories of personal information disclosed to third parties for such third\n\t\t\tparties’ direct marketing purposes during the immediately preceding calendar year, along with the\n\t\t\tnames and addresses of these third parties. A request may be made no more than once per calendar year\n\t\t\tand we are not required to respond to requests made by means other than through the email address\n\t\t\tabove."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v(
            'To the extent that any of our mobile applications of the Services collects\n\t\t\tpersonally identifiable information, that is done only as strictly necessary to enable us to provide\n\t\t\tthose Services (see "When We Collect Information" and "Cookies & Other Technologies", above), and\n\t\t\tthis cannot be disabled by "do not track" or other mechanisms available on your mobile Device’s\n\t\t\tbrowser.'
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }